import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const AnalyticsSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 25 23' fill='none'>
    <g clipPath='url(#clip0_9757_9290)'>
      <path
        d='M10.3001 9.68663C10.1173 9.52654 9.88381 9.44993 9.64943 9.47312C9.41505 9.49631 9.19833 9.61748 9.04546 9.81079L5.41981 14.3911C5.2642 14.5876 5.18724 14.8429 5.20586 15.1007C5.22448 15.3586 5.33715 15.5978 5.5191 15.7659C5.70104 15.934 5.93735 16.0172 6.17603 15.997C6.41472 15.9769 6.63623 15.8552 6.79184 15.6587L9.84641 11.8L12.0838 13.7579C12.257 13.9086 12.4756 13.9849 12.6978 13.9722C12.9199 13.9595 13.1298 13.8587 13.2873 13.689L17.9276 8.67644C18.0138 8.5865 18.0825 8.4789 18.1298 8.35994C18.1771 8.24097 18.202 8.11302 18.2031 7.98355C18.2041 7.85408 18.1813 7.72568 18.1359 7.60585C18.0905 7.48602 18.0235 7.37715 17.9387 7.28559C17.854 7.19404 17.7532 7.12164 17.6423 7.07261C17.5313 7.02358 17.4125 6.99891 17.2926 7.00004C17.1728 7.00116 17.0543 7.02806 16.9442 7.07916C16.8341 7.13027 16.7345 7.20455 16.6512 7.29768L12.5857 11.6888L10.3001 9.68663Z'
        fill='url(#paint0_linear_9757_9290)'
      />
      <path
        d='M21.2037 1C20.6104 0.999881 20.0303 1.17573 19.5369 1.5053C19.0434 1.83487 18.6588 2.30336 18.4317 2.85153C18.2045 3.3997 18.145 4.00292 18.2607 4.5849C18.3764 5.16688 18.6621 5.70149 19.0816 6.12111C19.5011 6.54072 20.0357 6.82651 20.6176 6.94231C21.1996 7.05811 21.8028 6.99874 22.351 6.7717C22.8992 6.54465 23.3678 6.16013 23.6975 5.66677C24.0272 5.17341 24.2031 4.59337 24.2031 4C24.2023 3.2047 23.8861 2.44219 23.3238 1.87977C22.7615 1.31736 21.999 1.00096 21.2037 1ZM21.2037 5.18962C20.9683 5.18974 20.7381 5.12002 20.5422 4.98929C20.3464 4.85855 20.1938 4.67266 20.1036 4.45515C20.0135 4.23764 19.9898 3.99828 20.0357 3.76734C20.0816 3.5364 20.195 3.32427 20.3615 3.15778C20.528 2.99129 20.7401 2.87792 20.9711 2.83201C21.202 2.7861 21.4414 2.80973 21.6589 2.89989C21.8764 2.99005 22.0623 3.14269 22.193 3.33852C22.3238 3.53434 22.3935 3.76454 22.3934 4C22.393 4.31541 22.2676 4.61781 22.0446 4.84084C21.8215 5.06387 21.5191 5.1893 21.2037 5.18962Z'
        fill='url(#paint1_linear_9757_9290)'
      />
      <path
        d='M21.2877 8.4197C21.0449 8.4197 20.812 8.51615 20.6403 8.68783C20.4686 8.85951 20.3722 9.09235 20.3722 9.33514V16.8772C20.3712 17.7499 20.0241 18.5865 19.4071 19.2036C18.7901 19.8208 17.9535 20.168 17.0808 20.1691H7.3261C6.4533 20.1681 5.61652 19.821 4.99935 19.2039C4.38218 18.5867 4.03504 17.75 4.03407 16.8772V7.12282C4.03504 6.25004 4.38218 5.41329 4.99935 4.79614C5.61652 4.179 6.4533 3.83186 7.3261 3.83089H16.1482C16.391 3.83089 16.6238 3.73444 16.7955 3.56276C16.9672 3.39108 17.0637 3.15823 17.0637 2.91544C17.0637 2.67265 16.9672 2.43981 16.7955 2.26813C16.6238 2.09645 16.391 2 16.1482 2H7.3261C5.9677 2.00097 4.66522 2.54101 3.70468 3.50151C2.74415 4.46202 2.20409 5.76446 2.20312 7.12282V16.8772C2.20409 18.2355 2.74415 19.538 3.70468 20.4985C4.66522 21.459 5.9677 21.999 7.3261 22H17.0808C18.4391 21.9989 19.7414 21.4588 20.7018 20.4983C21.6622 19.5378 22.2022 18.2354 22.2031 16.8772V9.33514C22.2031 9.21493 22.1794 9.09589 22.1334 8.98482C22.0874 8.87375 22.02 8.77283 21.935 8.68783C21.85 8.60282 21.7491 8.53539 21.638 8.48938C21.5269 8.44338 21.4079 8.4197 21.2877 8.4197Z'
        fill='url(#paint2_linear_9757_9290)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_9757_9290'
        x1='5.20312'
        y1='7'
        x2='18.6582'
        y2='7.74139'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_9757_9290'
        x1='18.2031'
        y1='1'
        x2='24.423'
        y2='1.23727'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_9757_9290'
        x1='2.20312'
        y1='2'
        x2='22.9359'
        y2='2.79089'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <clipPath id='clip0_9757_9290'>
        <rect width='24' height='22.8422' fill='white' transform='translate(0.953125 0.0234375)' />
      </clipPath>
    </defs>
  </svg>
);

export const AnalyticsColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AnalyticsSvg} {...props} />
);
